import { useQuery } from '@tanstack/react-query'
import { apiClient } from './client'

export interface SiteAddress {
  city?: string
  street?: string
  country?: string
}

export interface SiteSettings {
  phone_formatted?: string
  phone?: string
  email?: string
  address?: SiteAddress
  working_hours?: {
    display?: string
    weekdays?: string
    weekend?: string
  }
  social?: {
    telegram?: string
    instagram?: string
    vk?: string
  }
  [key: string]: unknown
}

interface SettingsResponse {
  success: boolean
  data: SiteSettings
}

/**
 * Хук для получения настроек сайта
 */
export function useSiteSettings() {
  return useQuery({
    queryKey: ['site-settings'],
    queryFn: () => apiClient<SettingsResponse>('/api/public/settings'),
    staleTime: 5 * 60 * 1000, // 5 минут
  })
}

/**
 * Форматирование адреса
 */
export function formatAddress(address?: SiteAddress): string {
  if (!address) return ''
  const parts = [address.city, address.street].filter(Boolean)
  return parts.join(', ')
}

